import generateRender from 'shared/utils/generateRender';
import DefaultLinkAccountHeader from './DefaultLinkAccountHeader';

const ModalHeader = generateRender({
  default: DefaultLinkAccountHeader,
});

export default ModalHeader;

